const firstLandingPage = () =>
  import(/* webpackChunkName: "landing-index1" */ '@/components/landing-pages/index1/index1.vue');
const secondLandingPage = () =>
  import(/* webpackChunkName: "landing-index2" */ '@/components/landing-pages/index2/index2.vue');

export default [
  {
    path: '/index1',
    name: 'index1',
    component: firstLandingPage,
    meta: {
      requiresAnonymous: true,
    },
  },
  {
    path: '/index2',
    name: 'index2',
    component: secondLandingPage,
    meta: {
      requiresAnonymous: true,
    },
  },
];
